/**
 * EndPointBrowserState.js
 *
 * Copyright (c) apploft. GmbH
 */

// States

const ready = Symbol('ready to go');

// Events

const select = Symbol('select a section');

function reducer({sections, section, type}, action) {
  switch (type) {
    case ready:
      switch (action.type) {
        case select:
          return {sections, section: action.section, type};

        default:
          throw new Error();
      }

    default:
      throw new Error();
  }
}

export {ready, select, reducer};
